

import React, { useState, useContext } from 'react';

import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel'

import AppContext from '../Context/AppContext';
import axios from '../axios';
import { useFormik } from 'formik';
import Modal from '../Widgets/Modal';

const UserDeleteModal = ({ hide, data, update }) => {
    const [visible, setVisible] = useState(true)
    const { sendMessage, toast, setBlocked } = useContext(AppContext)

    var formik = useFormik({
        initialValues: {
            id: data.id,
            name: data.name
        },
        validate: (data) => {
            let errors = {};
            return errors;
        },
        onSubmit: async (data) => {
            setBlocked(true)

            try {
                const response = await axios.post(`/users/delete`, {
                    id: data.id,
                });
                if (response.data.success) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: `Device ${data.name} deleted!`, life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: `Failed to delete ${data.name} device!`, life: 3000 });
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: `Failed to delete ${data.name} device!`, life: 3000 });
            }


            setBlocked(false)
            update()
            sendMessage(JSON.stringify({ type: `users_deleted` }))
            setVisible(false)
        }
    });

    const footer = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={() => { setVisible(false) }} />
            <Button label="Delete" icon="pi pi-check" className="m-0" severity="danger" type='submit' form='delete-user' />
        </React.Fragment>
    );

    return (
        <Modal header="Confirmation" visible={visible} onHide={() => setVisible(false)} transitionOptions={{ onExited: () => hide() }} footer={footer}>
            <form onSubmit={formik.handleSubmit} id='delete-user' className='formgrid grid gap-3 mb-3'>
                <Panel className='col-12' header={
                    <div className="flex align-items-center">
                        <label className="flex-1 font-medium white-space-nowrap overflow-hidden text-overflow-ellipsis">Delete user <b>{data.user}</b></label>
                    </div>
                } pt={{
                    header: { className: 'surface-hover' },
                    title: { className: 'w-full' }
                }}>
                    Are you sure you want to delete this user ?
                </Panel>
            </form>
        </Modal>
    );
}

export default UserDeleteModal;